export const STOCK_TAKE_UNSAVED_LEAVE_MESSAGE =
  'You have unsaved changes. Leave this stock take without saving?'

export const STOCK_TAKE_UNSAVED_HINT =
  'Unsaved counts — save before Order to par or Go back.'

export const shouldPromptStockTakeLeave = ({
  hasUnsavedChanges,
  isLocked,
} = {}) => Boolean(hasUnsavedChanges && !isLocked)

/** Flush the focused cell so Ask Ollie does not drop an uncommitted Par / In Stock. */
export const commitStockTakeInProgressCells = () => {
  if (typeof document === 'undefined') return
  const active = document.activeElement
  if (active && typeof active.blur === 'function') active.blur()
}
